module.exports = __webpack_public_path__ + "static/media/udemy1.b9ec5aff.png";